const API = process.env.REACT_APP_BACKEND_URL;

// Uploads a file to object storage via the backend, returns a permanent app-served URL.
export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}/api/upload`, { method: "POST", credentials: "include", body: fd });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.detail || "Upload failed");
  return `${API}${json.url}`;
};
